
/**
 * --- External Imports ---
 */
import { Condition, ConditionMode, useFormState } from "@ngt/forms-core";
import { FC } from "react";

/**
 * --- Internal Imports ---
 */
import { IFormFieldChildComponentProps } from "../types/FieldTypes";
import FormFieldComponent from "./FormFieldComponent";
import useFormFieldCondition from "../../../../hooks/validation/useFormFieldCondition";


/**
 * --- Child Field ---
 */
const FormFieldChildComponent: FC<IFormFieldChildComponentProps> = ({
    child,
    form
}) => {
    //
    // -- Hooks --
    const { value } = useFormState({ value: true });
    const { getFormFieldDisplayCondition } = useFormFieldCondition();

    const conditionFn = getFormFieldDisplayCondition(child);

    if (conditionFn) {
        return (
            <Condition
                condition={conditionFn}
                subscription={{ value }}
                mode={ConditionMode.Show}
            >
                <FormFieldComponent field={child} form={form} />
            </Condition>
        )
    }

    return (
        <FormFieldComponent field={child} form={form} />
    )
}

export default FormFieldChildComponent;